import { Env } from '/@/Env';
import { ModalProgrammatic } from 'buefy';

export let modalProgrammatic = null;

/**
 * @typedef ModalOptions
 * @type {boolean} active
 * @type {object|function} component
 * @type {Vue} parent - [DEPRECATED in Vue 3] No longer needed - app instance handles context
 * @type {object} props - Props to be binded to the injected component
 * @type {object} events - Events to be binded to the injected component
 * @type {string} content
 * @type {number|string} width
 * @type {boolean} hasModalCard
 * @type {string} animation
 * @type {boolean} canCancel
 * @type {function} onCancel
 * @type {string} scroll
 * @type {string} customClass
 */
export class Modal {
  static setApp(app) {
    if (modalProgrammatic) {
      return;
    }

    modalProgrammatic = new ModalProgrammatic(app);
  }
  /**
   * @var {String}
   */
  id;

  /**
   * @var {?BModalComponent}
   */
  component;

  /**
   * @var {ModalOptions}
   */
  options;

  constructor(options) {
    this.id = options.modalId;

    // Set default width if not provided
    if (!options.width) {
      options.width = '100%';
    }

    // In Vue 3 compat mode, always set hasModalCard to true if using a component
    // This tells Buefy to render the component as the modal content
    if (options.component && options.hasModalCard === undefined) {
      options.hasModalCard = true;
    }

    if ('fullScreen' in options) {
      options.props = options.props || {};
      options.props.fullScreen = options.fullScreen;
    }

    this.options = options;
  }

  /**
   * @returns {?string}
   */
  get name() {
    return this.options.component?.name;
  }

  /**
   * @param closeCallback
   * @returns {?BModalComponent}
   */
  show(closeCallback) {
    if (!modalProgrammatic) {
      throw new Error('Modal: app not initialized. Call Modal.setApp() first.');
    }
    // Buefy closes a modal through several paths (service close, Escape, outside click, the x button,
    // a content component emitting `close`) and only one of them reaches the wrapper below. The vnode
    // unmount hook fires on all of them, so the service learns about every close from a single place,
    // and it runs after Buefy has stripped the scroll lock in its own beforeUnmount.
    const component = modalProgrammatic.open({
      ...this.options,
      onVnodeUnmounted: () => closeCallback(this)
    });
    const componentClose = component.close;
    component.close = () => {
      try {
        componentClose.call(component);
      } catch (error) {
        console.warn(error);
      }
    };
    this.component = component;
  }

  close() {
    this.component?.close();
  }

  /**
   * @param id
   * @returns {boolean}
   */
  isId(id) {
    return [this.name, this.id].includes(id);
  }
}
